import JitinImg from "../../assets/jatin-prasada-slick.png";
//import PiyushImg from "../../assets/piyush-goyal-slick.png";
import PiyushImg from "../../assets/piyush-goyal-original.png";
export const MINISTERS_DATA = [
  {
    name: "Shri Piyush Goyal",
    designation: "Minister of Commerce & Industry",
    smallImage: {
      // url:
      //   'https://static.investindia.gov.in/s3fs-public/2019-08/Piyush%20Goyal_265x206.jpg',
      //url: 'https://react-slick.neostack.com/img/react-slick/abstract01.jpg',
      url: PiyushImg,
      alt: "Piyush Goyal"
    }
  },
  // {
  //   name: "Smt. Anupriya Singh Patel",
  //   designation: "Minister of State for Commerce and Industry",
  //   smallImage: {
  //     url:
  //       "https://static.investindia.gov.in/s3fs-public/2021-07/Min%20Pic1.png",
  //     alt: "Hasdeep Singh Puri"
  //   }
  // },
  // {
  //   name: "Shri Som Parkash",
  //   designation: "Minister of State for Commerce and Industry",
  //   smallImage: {
  //     url:
  //       "https://static.investindia.gov.in/s3fs-public/2019-08/Shri%20Som%20Parkash_265x206.jpg",
  //     alt: "Som Prakash"
  //   }
  // },
  {
    name: "Shri Jitin Prasada",
    designation: "Minister of State for Commerce and Industry",
    smallImage: {
      url: JitinImg,
      alt: "Jitin Prasada"
    }
  }
];

export const SliderSettings = {
  slidesToShow: 1,
  speed: 400,
  slidesToScroll: 1,
  arrows: false,
  variableWidth: true,
  infinite: true,
  focusOnSelect: true
};
